import { Box as MuiBox } from "@mui/material";
import {
  LicenseInfo as MuiLicenseInfo,
  muiXTelemetrySettings,
} from "@mui/x-license";
import { PagingSortingProvider } from "app/services/pagingSortingContext";
import { SelectedSubmissionProvider } from "app/services/selectedSubmissionService";
import { navbar } from "app/shared/config";
import {
  Alert,
  Body,
  DevelopmentInfo,
  Footer,
  Header,
  Navbar,
  useAlerts,
  useUsers,
} from "common";
import { MainContainer } from "common/components/Main-Container/MainContainer";
import ReactGA from "react-ga4";
import { useTranslation } from "react-i18next";

MuiLicenseInfo.setLicenseKey(window.RUNTIME_CONFIG.muiLicenseKey);
muiXTelemetrySettings.disableTelemetry();

export const App = () => {
  const { alert } = useAlerts();
  const { t } = useTranslation();
  const { loggedInUser, currentUser, accessDenied } = useUsers();

  if (
    currentUser.isLoaded &&
    !accessDenied &&
    window.RUNTIME_CONFIG.gaMeasurementId
  ) {
    ReactGA.initialize(window.RUNTIME_CONFIG.gaMeasurementId);
  }

  return (
    <>
      <DevelopmentInfo />
      <Header
        logoTitle={t("app.logoTitle")}
        logoSubtitle={t("app.logoSubtitle")}
        userDisplayName={loggedInUser.displayName}
      />
      <Body>
        {currentUser.isLoaded ? (
          <>
            <Navbar menuItems={navbar.items} width={navbar.width} />
            {alert.exists && <Alert />}
            {/* APP SPECIFIC: Wrapping the main container with MuiBox, SelectedSubmissionProvider and PagingSortingProvider */}
            <MuiBox sx={{ position: "relative" }}>
              <SelectedSubmissionProvider>
                <PagingSortingProvider>
                  <MainContainer idAttr="project-slug-main" />
                </PagingSortingProvider>
              </SelectedSubmissionProvider>
            </MuiBox>
          </>
        ) : (
          <>{alert.exists && <Alert />}</>
        )}
      </Body>
      <Footer
        copyrightYear={t("app.copyrightYear")}
        productVersion={window.RUNTIME_CONFIG.productVersion || __APP_VERSION__}
      />
    </>
  );
};
